import avatarUrl from '@/assets/images/logo/kolesa-avatar.png';
import axios from '@/axios';
import { userTypes, STATUS_NO_TOKEN } from '@/constants';

const actions = {

    /**
   * Проверка xdm авторизации
   *
   * @param {object} vuex
   * @param {object} vuex.dispatch
   * @param {object} payload
   * @return {Promise}
   */
    checkXdm({ dispatch }, payload) {
        return new Promise((resolve) => {
            const script = document.createElement('script');
            script.type = 'text/javascript';
            script.src = payload.assetUrl;
            script.onload = async () => {
                const { token } = window.xdm?.sess ?? {};

                if (token) {
                    const status = await dispatch('loginByToken', { token });

                    resolve(status);
                } else {
                    resolve(false);
                }
            };

            // хак для работы js файла от AUTH
            window.jQuery = {};
            document.getElementsByTagName('head')[0].appendChild(script);
        });
    },

    /**
   * Получение данных по сессии
   *
   * @param {Object} vuex
   * @param {Function} vuex.dispatch
   * @return {Promise}
   */
    getSession({ dispatch }) {
        return new Promise((resolve) => {
            axios.get('session')
                .then(({ data: { data } }) => {
                    dispatch('setUser', data);
                    resolve(true);
                })
                .catch(async (error) => {
                    const { assetUrl } = error?.response?.data ?? {};

                    if (error?.response?.status === STATUS_NO_TOKEN && assetUrl) {
                        const status = await dispatch('checkXdm', { assetUrl });

                        resolve(status);
                    } else {
                        resolve(false);
                    }
                });
        });
    },

    // /////////////////////////////////////////////
    // User/Account
    // /////////////////////////////////////////////
    /**
   * Авторизоваться на сервере по ключу
   *
   * @param {Object} vuex
   * @param {Function} vuex.commit
   * @param {Object} payload - данные на сервер
   * @param {String} payload.token - данные на сервер
   * @param vuex.dispatch
   * @return {Promise}
   */
    loginByToken({ dispatch, commit }, { token }) {
        return new Promise((resolve, reject) => {
            axios.get('login', {
                params: { token },
            })
                .then(async ({ data: { data } }) => {
                    await dispatch('setUser', data);

                    resolve(true);
                })
                .catch(() => {
                    resolve(false);
                });
        });
    },

    /**
   * Отправляет на сервер, что нужно разлогиниться.
   *
   * @param {Object} vuex
   * @param {Function} vuex.commit
   * @return {Promise}
   */
    logout({ commit }) {
        return new Promise((resolve, reject) => {
            axios.get('logout')
                .then(({ data }) => {
                    const { destination } = data;
                    commit('LOGOUT');

                    window.location = destination;
                    resolve(true);
                })
                .catch((error) => {
                    reject(error);
                });
        });
    },

    /**
   * Установить данные о юзере
   *
   * @param {Object} vuex
   * @param {Function} vuex.commit
   * @param {Object} user
   * @return {Promise}
   */
    setUser({ commit }, user) {
        commit('UPDATE_USER_INFO', {
            ...user,
            isAuthorized: true,

            photoURL: avatarUrl,

            userRole: userTypes[user.userType] ?? '',
        });
    },
};

export default actions;
